/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit MyLocations.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import * as fromFlow from 'Logic/ViewsFlow.js'
import ActionRequired from 'DesignSystem/ActionRequired/view.js'
import AddLocation from 'DesignSystem/Svgs/AddLocation/view.js'
import ButtonIconLabelOutline from 'DesignSystem/ButtonIconLabelOutline/view.js'
import FilterByProvider from './FilterByProvider/logic.js'
import InputSmall from 'DesignSystem/InputSmall/view.js'
import Item from './Item/view.js'
import ListItems from './ListItems/logic.js'
import MoreActions from './MoreActions/logic.js'
import React from 'react'
import { css } from "emotion"
FilterByProvider.displayName = 'FilterByProviderLogic'
ListItems.displayName = 'ListItemsLogic'
MoreActions.displayName = 'MoreActionsLogic'

let styles = {}
styles.Vertical = css({label: 'Vertical',
  flexGrow: 1,
flexShrink: 1,
flexBasis: "auto",
paddingLeft: 20,
paddingRight: 40,
paddingTop: 32,
overflowY: "hidden"})
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
alignItems: "center",
flexWrap: "wrap",
marginBottom: 20})
styles.Horizontal1 = css({label: 'Horizontal1',
  flexDirection: "row"})
styles.Vertical1 = css({label: 'Vertical1',
  flexBasis: "auto",
flexShrink: 1,
flexGrow: 1})

export default function MyLocations({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  valueFilter,
onChangeFilter,
isAdmin,
canInteract,
hasToAcceptAndSignAgreement,
filter,
viewPath= "/App/MyAccount/Content/Profile/Content/MyLocations",
isHovered
}) {
    
    
    
    let flow = fromFlow.useFlow()
let setFlowTo = fromFlow.useSetFlowTo(viewPath)
    
    

  return (<React.Fragment
>
<div
 data-testid="MyLocations.Vertical"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations"
 className={`views-block ${styles.Vertical}`}
>
<div
 data-testid="MyLocations.Horizontal"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations"
 className={`views-block ${styles.Horizontal}`}
>
<InputSmall
 data-testid="MyLocations.InputSmall"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations"
viewPath={`${viewPath}/InputSmall`}
 label="Filter Locations"
 placeholder="Filter Locations"
 marginRight={8}
 marginTop={8}
 value={valueFilter}
 onChange={onChangeFilter}
/>
{
isAdmin ? 
<ButtonIconLabelOutline
 data-testid="MyLocations.ButtonIconLabelOutline"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations"
viewPath={`${viewPath}/ButtonIconLabelOutline`}
 isDisabled={!canInteract}
 text="Add New Location"
 marginRight={8}
 marginTop={8}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Item/Content/Add'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Item/Content/Add'))}
>
{childProps => (
<AddLocation
{...childProps}
 data-testid="MyLocations.AddLocation"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations"
viewPath={`${viewPath}/AddLocation`}
 width={40}
 height={30}
 stroke={childProps.isHovered ? "rgb(0,162,255)" : "#606060"}
/>
)}
</ButtonIconLabelOutline>
 : null
}
<MoreActions
 data-testid="MyLocations.MoreActions"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations"
viewPath={`${viewPath}/MoreActions`}
 isProfile={true}
 marginRight="auto"
/>
<FilterByProvider
 data-testid="MyLocations.FilterByProvider"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations"
viewPath={`${viewPath}/FilterByProvider`}
/>
</div>
{
hasToAcceptAndSignAgreement ? 
<div
 data-testid="MyLocations.Horizontal:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations"
 className={`views-block ${styles.Horizontal1}`}
>
<ActionRequired
 data-testid="MyLocations.ActionRequired"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations"
viewPath={`${viewPath}/ActionRequired`}
 text="Accept and sign agreement"
 isDisabled={!isAdmin}
 onClick={() => setFlowTo("/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature")}
 isSelected={flow.has("/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature")}
/>
</div>
 : null
}
{
canInteract ? 
<div
 data-testid="MyLocations.Vertical:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations"
 className={`views-block ${styles.Vertical1}`}
>
<ListItems
 data-testid="MyLocations.ListItems"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations"
viewPath={`${viewPath}/ListItems`}
 filter={filter}
/>
</div>
 : null
}
<Item
 data-testid="MyLocations.Item"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyLocations"
viewPath={`${viewPath}/Item`}
/>
</div>
{children}
</React.Fragment>)
}